import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class InitAppStateService {
  private _initialized = signal(false);
  readonly initialized = this._initialized.asReadonly();
  setInitialized(initialized: boolean) {
    this._initialized.set(initialized);
  }
}
